import React, { useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, Field } from 'redux-form';

import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { CardElement, Modal, AddButton, TextInput, EmptyState, StatusChip } from '../../_Components';

const PhoneForm = () => (
    <div className="pc-fgrid">
        <Field name="name" required={true} component={TextInput} label="Имя" />
        <Field name="phone" required={true} component={TextInput} label="Внутренний" mono={true} />
    </div>
);

const DepartmentForm = () => (
    <Field name="name" required={true} component={TextInput} label="Название отдела" />
);

const NewPhoneBook = ({ formValues, change }) => {
    const [data, setData] = useState(formValues.transfer ? formValues.transfer : { departments: [] });
    const [activeNodekey, setActiveNodekey] = useState(data.departments[0] ? 0 : null);
    const [newDepartment, setNewDepartment] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [phoneForm, setPhoneForm] = useState(null);
    const [editPhoneKey, setEditPhoneKey] = useState(null);
    const [departmentForm, setDepartmentForm] = useState(null);
    const [editDepartmentKey, setEditDepartmentKey] = useState(null);
    const [query, setQuery] = useState('');

    const departments = data.departments || [];
    const active = activeNodekey != null ? departments[activeNodekey] : null;
    const rows = active ? (active.phonebook || []) : [];
    const q = query.trim().toLowerCase();
    const visible = q
        ? rows.filter((row) => `${row.name || ''} ${row.phone || ''}`.toLowerCase().includes(q))
        : rows;

    const changeDepartment = (key) => {
        setActiveNodekey(key);
        setQuery('');
    };

    const editDeartment = (form, key) => {
        setEditDepartmentKey(key);
        setDepartmentForm(form);
        setNewDepartment(!newDepartment);
    };

    const saveDepartment = (form) => {
        const next = { ...data, departments: [...(data.departments || [])] };
        if (editDepartmentKey != null && next.departments[editDepartmentKey]) {
            next.departments[editDepartmentKey] = {
                ...next.departments[editDepartmentKey],
                name: form.name,
            };
            setActiveNodekey(editDepartmentKey);
        } else {
            next.departments.push({ phonebook: [], ...form });
            setActiveNodekey(next.departments.length - 1);
        }
        setData(next);
        change('transfer', next);
        editDeartment();
    };

    const editPhone = (form, key) => {
        setEditPhoneKey(key);
        setPhoneForm(form);
        setOpenEdit(!openEdit);
    };

    const savePhone = (form) => {
        const next = { ...data, departments: [...(data.departments || [])] };
        const current = { ...next.departments[activeNodekey] };
        const book = [...(current.phonebook || [])];
        if (editPhoneKey != null && book[editPhoneKey]) {
            book[editPhoneKey] = form;
        } else {
            book.push(form);
        }
        current.phonebook = book;
        next.departments[activeNodekey] = current;
        setData(next);
        change('transfer', next);
        editPhone();
    };

    const deletePhone = (key) => {
        const next = { ...data, departments: [...(data.departments || [])] };
        const current = { ...next.departments[activeNodekey] };
        current.phonebook = (current.phonebook || []).filter((_, index) => index !== key);
        next.departments[activeNodekey] = current;
        setData(next);
        change('transfer', next);
    };

    return (
        <div className="pc-fill">
        <div className="pc-split pc-split--dir">
            <CardElement
                fill
                title="Отделы"
                subheader={<StatusChip tone="mono">{departments.length}</StatusChip>}
                action={<AddButton handleAddClick={() => editDeartment(null, null)} label="Добавить" />}
                content={(
                    <div className="pc-panel-body">
                        <div className="pc-tblwrap">
                            {departments.map((item, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    className={`pc-listbtn${index === activeNodekey ? ' is-cur' : ''}`}
                                    onClick={() => changeDepartment(index)}
                                    onDoubleClick={() => editDeartment(item, index)}
                                >
                                    <span className="pc-listbtn__t">{item.name}</span>
                                    <span className="pc-listbtn__n">{(item.phonebook || []).length}</span>
                                </button>
                            ))}
                            {departments.length === 0 && (
                                <EmptyState title="Нет отделов" description="Добавьте отдел, чтобы вести внутренние номера." />
                            )}
                        </div>
                    </div>
                )}
            />
            <CardElement
                fill
                title="Сотрудники"
                subheader={active ? <span className="pc-rescount">отдел: {active.name}</span> : null}
                action={active ? <AddButton handleAddClick={() => editPhone(null, null)} label="Добавить" /> : null}
                content={(
                    <div className="pc-panel-body">
                        {active ? (
                            <>
                                <div className="pc-toolbar">
                                    <TextField
                                        className="pc-search pc-search--wide"
                                        size="small"
                                        placeholder="Поиск по имени или номеру"
                                        value={query}
                                        onChange={(event) => setQuery(event.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon sx={{ fontSize: 16, color: 'var(--muted-2)' }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <span className="pc-rescount">
                                        {visible.length === rows.length
                                            ? `${rows.length}`
                                            : `${visible.length} из ${rows.length}`}
                                    </span>
                                </div>
                                <div className="pc-tblwrap">
                                    <table className="pc-cards-tbl">
                                        <thead>
                                            <tr>
                                                <th>Имя</th>
                                                <th style={{ width: 120 }}>Внутренний</th>
                                                <th style={{ width: 72 }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {visible.map((row) => {
                                                const key = rows.indexOf(row);
                                                return (
                                                    <tr key={`${row.phone}-${key}`}>
                                                        <td>{row.name}</td>
                                                        <td className="key">{row.phone}</td>
                                                        <td className="act">
                                                            <IconButton size="small" onClick={() => editPhone(row, key)}>
                                                                <EditIcon sx={{ fontSize: 16 }} />
                                                            </IconButton>
                                                            <IconButton size="small" onClick={() => deletePhone(key)}>
                                                                <DeleteOutlineIcon sx={{ fontSize: 16, color: 'var(--danger)' }} />
                                                            </IconButton>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    {visible.length === 0 && (
                                        <EmptyState
                                            title="В этом отделе никого нет"
                                            description="Добавьте сотрудника или измените поиск."
                                        />
                                    )}
                                </div>
                            </>
                        ) : (
                            <EmptyState title="Отдел не выбран" description="Выберите отдел слева." />
                        )}
                    </div>
                )}
            />
            {newDepartment && (
                <Modal
                    width={420}
                    title={departmentForm ? 'Редактировать отдел' : 'Создать отдел'}
                    open={newDepartment}
                    handleSaveClick={saveDepartment}
                    handleCloseClick={editDeartment}
                    fields={<DepartmentForm />}
                    initial={departmentForm}
                />
            )}
            {openEdit && (
                <Modal
                    width={480}
                    title={phoneForm ? 'Редактировать телефон' : 'Добавить телефон'}
                    open={openEdit}
                    handleSaveClick={savePhone}
                    handleCloseClick={editPhone}
                    fields={<PhoneForm />}
                    initial={phoneForm}
                />
            )}
        </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    const formValues = getFormValues('card')(state);
    return { formValues };
};

export default compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'card',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
    }),
)(NewPhoneBook);
